import axios from 'axios';

export {contact, subscriptions}
const contact = axios.create({
	baseURL: 'https://script.google.com/macros/s/AKfycbxPUjoA2CE26q9qjdV5s_xGyiiVDy-POzToPGj-nr3VjUz_48E/exec',
	headers: {
		'Content-Type': 'application/x-www-form-urlencoded'
	}
});


const subscriptions = axios.create({
	baseURL: 'https://script.google.com/macros/s/AKfycbyvaUQ25SyKgpbh1k7QN2VCfoWiRfYqdihCwmz8Lw_X1xymLzM/exec',
	headers: {
		'Content-Type': 'application/x-www-form-urlencoded'
	}
});